import { ProductionLineAssignmentsResults } from './production-line-assignments-results'
import { OptimisationMetrics } from './metrics/optimisation-metrics'
import { ExceptionDetail, Interval } from '@elderbyte/ngx-starter'
import { Instant } from '@js-joda/core'
import { ProductionLineAssignments } from './production-line-assignments'

export enum JobState {
  OPEN = 'OPEN',
  PROCESSING = 'PROCESSING',
  FINISHED = 'FINISHED',
  FAILED = 'FAILED',
}

export class Job {
  constructor(
    public id: string,
    public facilityId: string,
    public interval: Interval,
    public createdAt: Instant,
    public state: JobState,
    public startedAt: Instant,
    public completedAt: Instant,
    public metrics: OptimisationMetrics,
    public initialAssignments: ProductionLineAssignments,
    public optimizedAssignments: ProductionLineAssignmentsResults,
    public error: ExceptionDetail
  ) {}
}
